var _defs, _ellipse, _path, _path2, _path3, _circle, _path4, _path5, _path6, _path7, _circle2, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgActivityImageHealthReport1Small({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-2{fill:#fff}.cls-3{fill:#87bade}.cls-4,.cls-5,.cls-6{fill:none;stroke:#384a5f}.cls-4,.cls-6{stroke-linecap:round}.cls-4,.cls-5{stroke-miterlimit:10}.cls-6{stroke-linejoin:round}"))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.41,
    cy: 69.31,
    rx: 39,
    ry: 9.1,
    fill: "#c1e3e4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M60.8 14.8v48.61a2.73 2.73 0 01-2.72 2.72h-43.3a2.74 2.74 0 01-2.73-2.72V14.8a2.74 2.74 0 012.73-2.72h10.28a.8.8 0 00-.75.81v4.3h-8.38V61h41V17.19h-8.38v-4.3a.8.8 0 00-.76-.81h10.29a2.73 2.73 0 012.72 2.72z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M56.93 17.19V61h-41V17.19h8.38v.26a.82.82 0 00.81.82h22.62a.82.82 0 00.81-.82v-.26zm-31.15 8.62a1.81 1.81 0 10-1.8 1.8 1.8 1.8 0 001.8-1.8zm0 11.69A1.81 1.81 0 1024 39.3a1.8 1.8 0 001.78-1.8zm0 11.68A1.81 1.81 0 1024 51a1.8 1.8 0 001.78-1.82z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M47.79 12.08a.8.8 0 01.76.81v4.56a.82.82 0 01-.81.82H25.12a.82.82 0 01-.81-.82v-4.56a.8.8 0 01.75-.81h2.45a.81.81 0 00.82-.8V8.12a2.78 2.78 0 012.77-2.78h10.66a2.79 2.79 0 012.78 2.78v3.15a.8.8 0 00.8.8h2.45z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 23.98,
    cy: 25.81,
    r: 1.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24 35.69a1.81 1.81 0 11-1.81 1.81A1.8 1.8 0 0124 35.69zm0 11.69a1.81 1.81 0 11-1.81 1.8 1.8 1.8 0 011.81-1.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M29.33 52.39H50.4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M48.55 17.19h8.38v43.83h-41V17.19h8.38"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M28.73 29.01H49.8M29.33 40.7H50.4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 23.98,
    cy: 25.81,
    r: 1.8
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M25.78 37.5A1.81 1.81 0 1124 35.69a1.8 1.8 0 011.78 1.81zm0 11.68a1.81 1.81 0 11-1.8-1.8 1.8 1.8 0 011.8 1.8z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M47.74 12.08h10.34a2.73 2.73 0 012.72 2.72v48.61a2.73 2.73 0 01-2.72 2.72h-43.3a2.74 2.74 0 01-2.73-2.72V14.8a2.74 2.74 0 012.73-2.72h10.34"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M47.79 12.08h-2.45a.8.8 0 01-.8-.8V8.12a2.79 2.79 0 00-2.78-2.78H31.1a2.78 2.78 0 00-2.77 2.78v3.15a.81.81 0 01-.82.8h-2.45a.8.8 0 00-.75.81v4.56a.82.82 0 00.81.82h22.62a.82.82 0 00.81-.82v-4.55a.8.8 0 00-.76-.81z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M32.82 12.27h7.22"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66.61 52.48a7.45 7.45 0 00-14.89 0v11.28a4.6 4.6 0 00-2.76 2A14.63 14.63 0 1169.2 66a3.73 3.73 0 00-2.59-2.22v-11.3z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66.61 63.73A3.73 3.73 0 0169.2 66a14.64 14.64 0 01-20.2-.2 4.6 4.6 0 012.76-2 2.64 2.64 0 01.55-.06h3.31c0 .22.26 2.37 3.48 2.37s3.26-2.11 3.26-2.41h3.91a2 2 0 01.34.03z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M66.61 52.53v11.2a2 2 0 00-.34 0h-3.91v-3.54a8.1 8.1 0 002.77-6.37v-.83c-1.77-.34-3-2.88-3.37-3.65-.68.83-1.35 4.28-8.18 4.28v.2a8.45 8.45 0 002.09 5.75v4.13h-3.3a2.64 2.64 0 00-.55.06V52.48a7.45 7.45 0 0114.89 0z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.05 53v.83a8.1 8.1 0 01-2.77 6.37 4.81 4.81 0 01-3 1.1 5.09 5.09 0 01-3.7-1.72 8.45 8.45 0 01-2.09-5.75v-.2c6.83 0 7.5-3.45 8.18-4.28.33.76 1.61 3.3 3.38 3.65z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M62.36 60.25v3.45c0 .28-.08 2.37-3.29 2.37s-3.48-2.15-3.48-2.37v-4.12a5.09 5.09 0 003.7 1.72 4.81 4.81 0 003-1.1z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M66.61 52.53V63.7m0-11.43v.21m-14.89.05V63.7m0-11.43v.2m14.89.06v-.05a7.45 7.45 0 00-14.89 0v.05"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M55.59 59.57a8.45 8.45 0 01-2.09-5.75v-.2c6.83 0 7.5-3.45 8.18-4.28.33.77 1.6 3.31 3.37 3.65v.83a8.1 8.1 0 01-2.77 6.37 4.81 4.81 0 01-3 1.1 5.09 5.09 0 01-3.69-1.72zm2.08-2.1a2.14 2.14 0 002.77 0M69.2 66a3.73 3.73 0 00-2.59-2.22 2 2 0 00-.34 0h-3.91v-3.53"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M49 65.8a4.6 4.6 0 012.76-2 2.64 2.64 0 01.55-.06h3.3v-4.16"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M55.59 63.7c0 .22.26 2.37 3.48 2.37s3.29-2.07 3.29-2.37"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M69.2 66a14.64 14.64 0 10-9.91 4 14.57 14.57 0 009.91-4z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M60 54.44a1.31 1.31 0 011.59.11m-5.35-.11a1.31 1.31 0 011.59.11"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityImageHealthReport1Small);
export default __webpack_public_path__ + "static/media/activity-image-health_report_1-small.453194e01b81b48bf5c48d9488fff443.svg";
export { ForwardRef as ReactComponent };